module.exports = {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#download",
      toString: function () {
        return this.url;
      }
    }